/**
 * Common regular expressions
 * @module util/regex
 */

/**
 * Email validation regex
 * @type {string}
 */ // eslint-disable-next-line max-len
export const email =
  '^(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'

// See https://regex101.com/r/dE6cL8/3
/**
 * Password validation regex; 6 alphanumeric characters
 * @type {string}
 */
export const password = '^.{8,40}$'
